import { ICampaignOverviewSubmitObject } from "../../app/store/campaign/campaignOverview/types";
import CampaignOverviewSubmitObject from "../../entities/campaigns/CampaignOverviewSubmitObject";
import { AppState } from "../../app/store/rootReducers";

export default class CampaignSubmitObjectFactory {

  static create(state: AppState): ICampaignOverviewSubmitObject {
    return new CampaignOverviewSubmitObject(state);
  }

}
